import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Lead } from "../../../types/leads";
import { RootState } from "../../../store";
import * as triplinkService from '../../../utils/triplinkService'
import { logout } from "../auth/authSlice";

interface LeadsState {
  body: Lead[];
  updating: boolean;
}

const initialState: LeadsState = {
  body: [],
  updating: false,
}

export const fetchLeads = createAsyncThunk(
  'leads/fetchLeads',
  async (params, {dispatch, getState}) => {
    const state: RootState = (getState() as RootState);
    const accessToken = state.accessToken.body;
    if (!accessToken) {
      throw new Error('Cannot fetchLeads without accessToken')
    }
    const result = await triplinkService.getMyLeads(accessToken);

    return result;
  }
)

const leadsSlice = createSlice({
  name: 'leads',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.body = []
      state.updating = false
    })
    .addCase(fetchLeads.pending, (state, action) => {
      state.updating = true
    })
    .addCase(fetchLeads.fulfilled, (state, action) => {
      state.body = action.payload
      state.updating = false
    })
    .addCase(fetchLeads.rejected, (state, action) => {
      state.body = []
      state.updating = false
    })
  }
})

export const selectLeads = (state: RootState) => state.leads;

export default leadsSlice.reducer